import { useEffect } from "react";
import { Button, Modal, Form } from "antd";

export default function DeleteCustomer({
  selected,
  isVisible,
  setDeleteModal,
}: any) {
  const { booking_id, source_name } = selected;

  const [form] = Form.useForm();

  useEffect(() => {}, [selected]);

  const onSubmit = async () => {
    setDeleteModal(false);
  };

  const hideModal = async () => {
    setDeleteModal(false);
  };

  return (
    <Modal
      visible={isVisible}
      title="Delete Delete"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="DeleteBooking"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          // loading={isLoading}
          danger
        >
          Delete
        </Button>,
      ]}
    >
      <Form id="DeleteBooking" form={form} onFinish={onSubmit}>
        <div>
          <p className="text-center font-bold">
            Are you sure you want to delete this booking
            <span className="text-red-500 ml-1">{source_name}</span>
          </p>
        </div>
      </Form>
    </Modal>
  );
}
